$(document).ready(function($) {
  $("#map").each(function () {
    var points = [];
    var marker = null;
    var selectFilters = [];
    var markers = [];
    var listings = document.getElementById('listings');
    var token = $(".tv-map-container").data('token');
    var filteredGeojson = {
        type: 'FeatureCollection',
        features: [],
    };
    mapboxgl.accessToken = token;
    /**
    * Add the map to the page
    */


    var iconTV = L.icon({
    iconUrl: RAILS_ASSET_URL('favicon.png'),
    iconRetinaUrl: RAILS_ASSET_URL('favicon.png'),
    iconSize: [38, 38], // size of the icon
    });

    var map = new mapboxgl.Map({
        container: 'map',
        style: 'https://api.maptiler.com/maps/73e6b383-2e17-41a1-8aaf-ddb2808be86e/style.json?key=BrU86IOygzoFf5z1Lm0m',
        center:[68.582748,32.882004],
        zoom: 1,
        scrollZoom : false,
        boxZoom  : true,
        doubleClickZoom : true,
    });
    map.addControl(new mapboxgl.NavigationControl());
    $('#map .detail-point').each(function(){
        points.push({type: 'feature', 'geometry': {'type': 'Point','coordinates': [$(this).data('lng'),$(this).data('lat')]},'properties': { title:  $(this).data('title'), address: $(this).data('address'),city: $(this).data('city'), brands: $(this).data('brands'), link: $(this).data('link')}});
    });


    var stores = {
    'type': 'FeatureCollection',
    'features': points
    };

    /**
    * Assign a unique id to each store. You'll use this 'id'
    * later to associate each point on the map with a listing
    * in the sidebar.
    */
    stores.features.forEach(addId)
    function addId(store_id, i) {
        store_id.properties.id = i;
    }

    /**
    * Wait until the map loads to make changes to the map.
    */
    map.on('load', function() {
        /**
        * This is where your '.addLayer()' used to be, instead
        * add only the source without styling a layer
        */
        map.addSource('places', {
            'type': 'geojson',
            'data': stores
        });

        /**
        * Create a new MapboxGeocoder instance.
        */
        var geocoder = new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker: false,
        });

        /**
        * Add all the things to the page:
        * - The location listings on the side of the page
        * - The search box (MapboxGeocoder) onto the map
        * - The markers onto the map
        */
        buildLocationList(stores);
        document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
        addMarkers();
        applyFilters();

        /**
        * Listen for when a geocoder result is returned. When one is returned:
        * - Calculate distances
        * - Sort stores by distance
        * - Rebuild the listings
        * - Adjust the map camera
        * - Open a popup for the closest store
        * - Highlight the listing for the closest store.
        */
        geocoder.on('result', function(event) {
            /* Get the coordinate of the search result */
            var searchResult = event.result.geometry;

            if (event.result.place_type[0] == 'country') {
                regionNamesInEnglish = new Intl.DisplayNames(['en'], {type: 'region'});
                city = regionNamesInEnglish.of(event.result.properties.short_code.toUpperCase()).toLowerCase();
            }
            /**

            * Calculate distances:
            * For each store, use turf.disance to calculate the distance
            * in miles between the searchResult and the store. Assign the
            * calculated value to a property called 'distance'.
            */
            var options = { units: 'kilometers' };
            if (filteredGeojson.features.length  > 0) {

                filteredGeojson.features.forEach(function(store){
                    store.properties.distance = turf.distance(
                    searchResult,
                    store.geometry,
                    options
                    );
                });

                /**
                * Sort stores by distance from closest to the 'searchResult'
                * to furthest.
                */
                filteredGeojson.features.sort(function(a, b) {
                    if (a.properties.distance > b.properties.distance) {
                        return 1;
                    }
                    if (a.properties.distance < b.properties.distance) {
                        return -1;
                    }
                    return 0; // a must be equal to b
                });

                /**
                * Rebuild the listings:
                * Remove the existing listings and build the location
                * list again using the newly sorted stores.
                */
                var listings = document.getElementById('listings');
                while (listings.firstChild) {
                    listings.removeChild(listings.firstChild);
                }
                buildLocationList(filteredGeojson);

                /* Open a popup for the closest store. */

                /** Highlight the listing for the closest store. */
                var activeListing = document.getElementById(
                    'listing-' + filteredGeojson.features[0].properties.id
                );
                if (activeListing != null) {
                    activeListing.classList.add('active');
                }

            }  else {
                stores.features.forEach(function(store){
                    store.properties.distance = turf.distance(
                    searchResult,
                    store.geometry,
                    options
                    );

                });

                stores.features.forEach(function(store) {
                    if (event.result.place_type[0] == "country") {
                        if (city != store.properties.city) {
                              store.properties.disabled = true;
                        }
                        else {
                            store.properties.disabled = false;
                        }
                    }
                    else
                    {
                        if (store.properties.distance > 300) {
                            store.properties.disabled = true;
                        }
                        else {
                            store.properties.disabled = false;
                        }
                    }
                });

                /**
                * Sort stores by distance from closest to the 'searchResult'
                * to furthest.
                */
                stores.features.sort(function(a, b) {
                    if (a.properties.distance > b.properties.distance) {
                        return 1;
                    }
                    if (a.properties.distance < b.properties.distance) {
                        return -1;
                    }
                    return 0; // a must be equal to b
                });

                /**
                * Rebuild the listings:
                * Remove the existing listings and build the location
                * list again using the newly sorted stores.
                */
                var listings = document.getElementById('listings');
                while (listings.firstChild) {
                    listings.removeChild(listings.firstChild);
                }
                buildLocationList(stores);

                /* Open a popup for the closest store. */
                if (stores.features[0] != 'undefined') {
                     label = stores.features[0].properties.id
                }
                else {
                 label = ""
                }
                /** Highlight the listing for the closest store. */
                var activeListing = document.getElementById(
                    'listing-' + label
                );
                if (activeListing != null) {
                    activeListing.classList.add('active');
                }
            }



            /**
            * Adjust the map camera:
            * Get a bbox that contains both the geocoder result and
            * the closest store. Fit the bounds to that bbox.
            */
            var bbox = getBbox(stores, 0, searchResult);
            map.fitBounds(bbox, {
                padding: 100
            });
        });

        map.setPaintProperty('water', 'fill-color', '#dcd4c2');
    });

    /**
    * Using the coordinates (lng, lat) for
    * (1) the search result and
    * (2) the closest store
    * construct a bbox that will contain both points
    */
    function getBbox(sortedStores, storeIdentifier, searchResult) {
        var lats = [
            sortedStores.features[storeIdentifier].geometry.coordinates[1],
            searchResult.coordinates[1]
        ];
        var lons = [
            sortedStores.features[storeIdentifier].geometry.coordinates[0],
            searchResult.coordinates[0]
        ];
        var sortedLons = lons.sort(function(a, b) {
            if (a > b) {
                return 1;
            }
            if (a.distance < b.distance) {
                return -1;
            }
                return 0;
            });
            var sortedLats = lats.sort(function(a, b) {
            if (a > b) {
                return 1;
            }
            if (a.distance < b.distance) {
                return -1;
            }
            return 0;
        });
        return [
            [sortedLons[0], sortedLats[0]],
            [sortedLons[1], sortedLats[1]]
        ];
    }

    /**
    * Add a marker to the map for every store listing.
    **/
    function addMarkers() {
        /* For each feature in the GeoJSON object above: */
        stores.features.forEach(function(marker) {
            /* Create a div element for the marker. */
            var el = document.createElement('div');
            /* Assign a unique 'id' to the marker. */
            el.id = 'marker-' + marker.properties.id;
            /* Assign the 'marker' class to each marker for styling. */
            el.className = 'marker';

            /**
            * Create a marker using the div element
            * defined above and add it to the map.
            **/
            var marker_single = new mapboxgl.Marker(el, { offset: [0, -23] }, {icon: iconTV})
            .setLngLat(marker.geometry.coordinates)
            .addTo(map);

            markers.push(marker);

            /**
            * Listen to the element and when it is clicked, do three things:
            * 1. Fly to the point
            * 2. Close all other popups and display popup for clicked store
            * 3. Highlight listing in sidebar (and remove highlight for all other listings)
            **/
            el.addEventListener('click', function(e) {
                markers.forEach(function(m){
                    if ('marker-' + m.properties.id == e.target.id){
                        flyToStore(m);
                        createPopUp(m);
                        var activeItem = document.getElementsByClassName('active');
                        if (activeItem[0]) {
                            activeItem[0].classList.remove('active');
                        }
                        var listing = document.getElementById(
                            'listing' + m.properties.id
                        );
                        listing.classList.add('active');
                    }
                });

            });
        });
    }

    /**
    * Add a listing for each store to the sidebar.
    **/
    function buildLocationList(stores) {
        stores.features.forEach(function(store_list) {
            /* Add a new listing section to the sidebar. */
            var listings = document.getElementById('listings');
            var listing = listings.appendChild(document.createElement('div'));
            /* Assign a unique 'id' to the listing. */
            listing.id = 'listing' + store_list.properties.id;
            /* Assign the 'item' class to each listing for styling. */
             if (store_list.properties.disabled == true) {
                listing.className = "item disabled";
            } else {
                listing.className = "item";
            }
            /* Add the link to the individual listing created above. */
            var link = listing.appendChild(document.createElement('a'));
            link.href = '#';
            link.className = 'title text-black-400';
            link.id = 'link-' + store_list.properties.id;
            link.innerHTML = '' + store_list.properties.address;

            /* Add details to the individual listing. */
            var details = listing.appendChild(document.createElement('div'));
            details.innerHTML = store_list.properties.title;
            if (store_list.properties.distance) {
                var roundedDistance =
                Math.round(store_list.properties.distance * 100) / 100;
                details.innerHTML += '<div><strong>'+ roundedDistance +' Km away</strong></div>';
            }


            /**
            * Listen to the element and when it is clicked, do four things:
            * 1. Update the 'currentFeature' to the store associated with the clicked link
            * 2. Fly to the point
            * 3. Close all other popups and display popup for clicked store
            * 4. Highlight listing in sidebar (and remove highlight for all other listings)
            **/
            link.addEventListener('click', function (e) {
                e.preventDefault();
                stores.features.forEach(function(feature) {
                    if (e.target.id === 'link-' + feature.properties.id) {
                        flyToStore(feature);
                        createPopUp(feature);
                    }
                });
                var activeItem = document.getElementsByClassName('active');
                if (activeItem[0]) {
                activeItem[0].classList.remove('active');
                }
                this.parentNode.classList.add('active');
            });
        });
    }

    /**
    * Use Mapbox GL JS's 'flyTo' to move the camera smoothly
    * a given center point.
    **/
    function flyToStore(currentFeature) {
        map.flyTo({
            center: currentFeature.geometry.coordinates,
            zoom: 15
        });
    }

    /**
    * Create a Mapbox GL JS 'Popup'.
    **/
    function createPopUp(currentFeature) {
        var popUps = document.getElementsByClassName('mapboxgl-popup');
        if (popUps[0]) popUps[0].remove();

        var popup = new mapboxgl.Popup({ closeOnClick: false })
        .setLngLat(currentFeature.geometry.coordinates)
        .setHTML(
        "<div class='map-popup-inner'><div class='title'><h2>" + currentFeature.properties.title + "</h2></div><p class='text'>" + currentFeature.properties.address + "<br><a href='" + currentFeature.properties.link + "'>More info </a></p></div>"
        )
        .addTo(map);
    }

    function applyFilters() {
        var filterForm = document.getElementById('brands');

        filterForm.addEventListener('change', function () {
            var filterOptionHTML = this.getElementsByClassName('filter-option');
            var filterOption = [].slice.call(filterOptionHTML);
            var geojSelectFilters = [];
            var geojCheckboxFilters = [];

            filteredGeojson.features = [];
            // var filteredFeatures = [];
            // filteredGeojson.features = [];
            if (this.value ==  "") {
                filteredGeojson.features = stores.features
            }
            else {
                var geojFilter = ["brands", this.value];
                geojSelectFilters.push(geojFilter);
                var value = this.value;
                var removeIds = [];
                stores.features.forEach(function(feature) {
                    if (feature.properties["brands"].includes(parseInt(value))) {
                        function  checkFilter(f){
                            return f.properties.id === feature.properties.id
                        }
                        if (filteredGeojson.features.filter(checkFilter).length === 0) {
                        filteredGeojson.features.push(feature);
                        }
                    }
                });
            }

            //map.getSource('locationData').setData(filteredGeojson);
            var listings = document.getElementById('listings');
            while (listings.firstChild) {
                listings.removeChild(listings.firstChild);
            }
            buildLocationList(filteredGeojson);
        });
        }

  });

});
